<template>
  <div>
    <Mainlayout></Mainlayout>

    <CCard class="custom-Quizcard h-100 mt-5" align="center">
      <CCol sm="12" class="justify-content-center">
        <CContainer>
          <CCol class="custom-margin">
            <br />
            <br />
            <br />
            <br />
            <br />
            <CRow>
              <h3 class="text-left mt-4 ml-5 text-black bold col-12">
                Leaderboard
                <img src="../assets/img/podium.png" width="50px" />
              </h3>
            </CRow>
          </CCol>
          
        </CContainer>
      </CCol>
      <table class="table table-responsive-sm table-striped">
            <tbody>
              <tr
                v-for="(item, index) in LeaderBoard"
                v-bind:key="item.quizScoreId"
              >
                <td style="width: 10%">
                  <span v-if="index == 0">
                    <img src="../assets/img/gold.png" width="30px" />
                  </span>
                  <span v-else-if="index == 1">
                    <img src="../assets/img/silver.png" width="30px" />
                  </span>
                  <span v-else-if="index == 2">
                    <img src="../assets/img/bronze.png" width="30px" />
                  </span>
                  <span v-else>
                    <strong style="font-size: 18px" class="custom-font mt-5">
                      {{ index + 1 }}
                    </strong>
                  </span>
                </td>
                <td style="width: 10%">
                  <div class="text-left">
                    <span v-if="item.studentProfilePhoto != null">
                      <img
                        width="35px"
                        height="35px"
                        :src="getPic(index)"
                        class="m-0 box-shadow"
                        style="border-radius: 50%; border: 1px solid #eee"
                      />
                    </span>
                    <span v-else>
                      <img
                        width="35px"
                        height="35px"
                        class="m-0 box-shadow"
                        src="../assets/img/user.png"
                        style="border-radius: 50%; border: 1px solid #eee"
                      />
                    </span>
                  </div>
                </td>
                <td style="width: 20%" class="col-2 text-left">
                  <strong class="custom-font">{{ item.studentName }}</strong>
                </td>
                <td class="col-3 text-right" style="width: 30%">
                  <h6>
                    <strong
                      style="color: #180c85; white-space: nowrap"
                      class="mr-4 custom-font"
                    >
                      {{ item.studentScore.toFixed(2) }} %</strong
                    >
                  </h6>
                </td>
              </tr>
            </tbody>
          </table>
    </CCard>
  </div>
</template>




<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import moment from "moment";
import backgroundBanner from "../assets/img/bgApps.jpg";
import _ from "lodash";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-timepicker", VueTimepicker);
Vue.component("v-select", vSelect);
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
import Mainlayout from "../containers/TheHeaderWebTutor.vue";

//insert table
//import CTableWrapper from './Table.vue'
//import usersData from '../users/UsersData'

// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
export default {
  name: "Login",
  components: {
    PulseLoader,
    Mainlayout,
  },
  data() {
    return {
      backgroundBanner,
      LeaderBoard: [],
      photoURL: "",
    };
  },
  async mounted() {
    this.GetLeaderBoard();
  },
  computed: {},
  methods: {
    async GetLeaderBoard() {
      this.$API
        .get(
          this.$QuizTeacherLeaderBoard +
            "?quizTitleId=" +
            this.$route.query.quizTitleId + 
            "&userId=" +
            this.$route.query.userId,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.LeaderBoard = response.data;
            this.getPic(this.LeaderBoard.studentProfilePhoto);
          }
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    getPic(index) {
      return (
        "https://pickiddo.com/" + this.LeaderBoard[index].studentProfilePhoto
      );
    },
  },
};
</script>
<style>
#fb-root{
  display:none;
}
</style>